import * as React from "react";
import "./ProjectTimelineStyle.css";
import {useSelector} from "react-redux";


export interface IProjectComponent {
    component: string
    years: number[]
}

const ProjectTimeline = () => {
    const components = useSelector((state: any) => state?.projectInfo?.projectComponents)
    const years = useSelector((state: any) => state?.projectInfo?.years)
    const sortedYears = [...years].sort((a: number, b: number) => a - b);
    return (
        <>
            <div className="table-container">
                <table>
                    <thead>
                    <tr>
                        <th>Project Component</th>
                        {sortedYears.map((y: number) => <th key={"th-" + y}>{y}</th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {components?.map((c: IProjectComponent, index: number) => (
                        <tr key={"tr_" + index}>
                            <td key={"td_" + index} style={{"color": "black"}}>{c?.component}</td>
                            {sortedYears?.map((y: number) => {
                                const index = c?.years.findIndex(a => a === y)
                                return (
                                    <td key={"td_" + index + "_" + y} className={index !== -1 ? "valueBackground" : ""}>
                                        {index !== -1 ? "X" : ""}
                                    </td>)
                            })}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};
export default ProjectTimeline;
